import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as common from '../../../../../../../../common'
import * as category from '../category'

export const RESOURCE = {
  payload: {
    modelId: category.MODEL_ID,
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[,]}',
      [PartialId.Standard.create('code')]:
        common.FaFunction.Category.Standard.Code.OperationsAndMaintenance,
      [PartialId.Standard.create('descr')]:
        'Standard operations and maintenance',
      [PartialId.Standard.create('id')]:
        common.FaFunction.Category.Standard.Id.from(
          common.FaFunction.Category.Standard.Code.OperationsAndMaintenance,
        ),
      [PartialId.Standard.create('type')]: common.FaFunction.Type.Facilities,
      [PartialId.Standard.create('is_sponsored')]: false,
      [PartialId.Standard.create('name')]: 'Operations & Maintenance',
      [PartialId.Standard.create('position')]:
        common.FaFunction.Category.Standard.Position.from(
          common.FaFunction.Category.Standard.Code.OperationsAndMaintenance,
        ),
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
